import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
    withStyles,
    WithStyles,
    Card,
    CardContent,
    Typography,
    Grid,
    createStyles,
    Theme,
    Button,
    List,
    ListItem,
    ListItemIcon,
    Icon,
    Hidden,
    Dialog,
    DialogContent,
    IconButton,
    useMediaQuery,
    useTheme,
    InputAdornment,
    FormControl,
    OutlinedInput,
} from '@material-ui/core';
//import { addFormSubmitWithEmail } from '../../config/googleTagManager'
import { withTranslation, WithTranslation, useTranslation } from 'react-i18next';
import CloseCircleIcon from 'mdi-react/CloseCircleIcon';
import Api from '../../services/applications'
import ApartmentsApi from '../../services/apartments'
import { useSelector } from 'react-redux';
import { selectUserId } from '../../selectors/users';
import LoadingContainer from '../../components/LoadingContainer/LoadingContainer'
import ageGroup from '../../images/applicantWatcher/ageGroup.svg'
import creditStatus from '../../images/applicantWatcher/creditStatus.svg'
import depositMethod from '../../images/applicantWatcher/depositMethod.svg'
import lifeSituation from '../../images/applicantWatcher/lifeSituation.svg'
import peopleAmount from '../../images/applicantWatcher/peopleAmount.svg'
import pets from '../../images/applicantWatcher/pets.svg'
import avatar from '../../images/applicantWatcher/avatar.svg'
import searchDude from '../../images/applicantWatcher/searchDude.svg'
import checkMark from '../../images/applicantWatcher/checkMark.svg'
import closeIcon from '../../images/applicantWatcher/closeIcon.svg'
import suggestIcon from '../../images/suggest.svg'
import { toast } from 'react-toastify'
import config from '../../config/config'
import { resolveCityByPostalCode } from '../../services/googlePlaces'

interface OwnProps {
    // You can define any necessary props here
}

interface DispatchProps {
    // Define any necessary dispatch props here
}

interface PropsFromState {
    // Define any necessary state props here
}

interface ComponentProps extends OwnProps, DispatchProps, PropsFromState, WithTranslation, WithStyles { }

const ApplicantWatcher: React.FC<ComponentProps> = (props: ComponentProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { classes } = props
    const [applications, setApplications] = useState([]);
    //const [filteredApplications, setFilteredApplications] = useState([]);
    const [allApplications, setAllApplications] = useState([]);
    const [apartments, setApartments] = useState([]);
    const [cache, setCache] = useState([]); // Cache of fetched applicants
    const [squareMeters, setSquareMeters] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [open, setOpen] = React.useState(false);
    const [selectedApplicant, setSelectedApplicant] = React.useState(null);
    const [isLoading, setLoading] = useState(false)
    const [isFiltering, setIsFiltering] = useState(true)
    const loggedUserId = useSelector(selectUserId);
    const { t } = useTranslation();
    const screenWidth = window.innerWidth;
    const maxApplicationsToShow = screenWidth < 600 ? 3 : 6;
    const [totalApplications, setTotalApplications] = useState([]);
    const [filterEmptyText, setFilterEmptyText] = useState("")
    const [marketingOrConfirmedApartments, setMarketingOrConfirmedApartments] = useState([]);
    const [hasPrefilledPostalCode, setHasPrefilledPostalCode] = useState(false);
    const [autoFilterApplied, setAutoFilterApplied] = useState(false);

    const handleLoadMore = () => {
        const nextApplications = cache.slice(0, maxApplicationsToShow);

        if (nextApplications.length === maxApplicationsToShow) {
            setApplications(prevApplications => [...prevApplications, ...nextApplications]);
            setCache(prevCache => prevCache.slice(maxApplicationsToShow));
        } else {
            fetchApplications();
        }
    };

    const fetchApplications = async () => {
        setLoading(true);
        try {
            const result = await Api.listApplications(); // Fetch all applications

            // Filter out applicants without a profile picture
            // const applicationsWithProfilePictures = result.filter(app => app.data && app.data.profilePicture);

            // Separate applications that match both, one, or neither criteria
            const matchedBothCriteria = [];
            const matchedOneCriteria = [
            ];
            const matchedNoneCriteria = [];

            result.forEach(app => {
                const { data } = app;
                if (data.creditStatus !== 'bad' && data.depositPaymentMethod !== 'kelaObligation') {
                    matchedBothCriteria.push(app);
                } else if (data.creditStatus !== 'bad' || data.depositPaymentMethod !== 'kelaObligation') {
                    matchedOneCriteria.push(app);
                } else {
                    matchedNoneCriteria.push(app);
                }
            });

            matchedBothCriteria.sort((a, b) => b.createdAt - a.createdAt);
            matchedOneCriteria.sort((a, b) => b.createdAt - a.createdAt);
            matchedNoneCriteria.sort((a, b) => b.createdAt - a.createdAt);

            // Concatenate arrays preserving the order of applications
            const orderedApplications = matchedBothCriteria.concat(matchedOneCriteria, matchedNoneCriteria);
            //console.log(orderedApplications);

            setAllApplications(orderedApplications);
            setApplications(orderedApplications.slice(0, maxApplicationsToShow));
            setCache(orderedApplications.slice(maxApplicationsToShow));
            setTotalApplications(orderedApplications.length);
            setLoading(false);
        } catch (error) {
            console.error("There was an error fetching the applications: ", error);
            setLoading(false);
        }
    };

    const updateApartmentsData = async (targetPostalCode?: string, targetCity?: string | null) => {
        setIsFiltering(true)
        setFilterEmptyText("");
        setLoading(true);

        const getApartmentsData = () => {
            if (apartments?.length) {
                return Promise.resolve(apartments);
            }

            return Api.getApartmentsForApplications(allApplications)
                .then(fetched => {
                    setApartments(fetched);
                    return fetched;
                });
        };

        return getApartmentsData()
            .then(apartmentsData => {
                const normalizedPostalCode = (targetPostalCode ?? postalCode).trim();
                const normalizedCity = (targetCity || '').trim().toLowerCase();
                const parsedSquareMeters = parseFloat(squareMeters);
                const roundedSquareMeters = isNaN(parsedSquareMeters)
                    ? null
                    : (String(parsedSquareMeters).includes('.') && String(parsedSquareMeters).split('.')[1].length > 1)
                        ? Math.ceil(parsedSquareMeters)
                        : parsedSquareMeters;

                const filteredApplications = (() => {
                    if (!normalizedPostalCode && !normalizedCity) {
                        return allApplications;
                    }

                    const filteredApartments = apartmentsData.filter(({ information }) => {
                        const apartmentPostalCode = information.postalCode
                            ? information.postalCode.toString().trim()
                            : '';
                        const matchesPostalCode = normalizedPostalCode
                            ? apartmentPostalCode === normalizedPostalCode
                            : false;
                        const apartmentCity = information.postalArea
                            ? information.postalArea.toString().trim().toLowerCase()
                            : '';
                        const matchesCity = normalizedCity
                            ? apartmentCity === normalizedCity
                            : false;
                        const matchesSquareMeters =
                            roundedSquareMeters === null ||
                            Math.abs(information.squareMeters - roundedSquareMeters) <= 10;

                        return matchesSquareMeters && (matchesPostalCode || matchesCity);
                    });

                    const filteredApartmentIds = new Set(filteredApartments.map(a => a.apartmentId));

                    return allApplications.filter(app =>
                        filteredApartmentIds.has(app.apartmentId)
                    );
                })();

                setApplications(filteredApplications.slice(0, maxApplicationsToShow));
                const remaining = filteredApplications.slice(maxApplicationsToShow);
                setCache(remaining);
                setTotalApplications(filteredApplications.length);
            })
            .catch(error => {
                // Handle error if needed
                // console.error("Error filtering applications:", error);
            })
            .finally(() => {
                const delay = apartments?.length ? 300 : 0;
                setTimeout(() => {
                    setLoading(false)
                    setIsFiltering(false)
                }, delay)
            });
    }

    const applyFilter = async (code: string, options: { allowEmpty?: boolean } = {}) => {
        const { allowEmpty = false } = options;
        const trimmedPostalCode = code.trim()

        if (!trimmedPostalCode) {
            if (!allowEmpty) {
                setFilterEmptyText(t('applicantWatcher.filterEmptyText'));
                return;
            }
            setFilterEmptyText("");
            await updateApartmentsData('', '');
            return;
        }

        const normalizedPostalCode = trimmedPostalCode.replace(/\s+/g, '');
        const isValidPostalCode = /^\d{5}$/.test(normalizedPostalCode);

        if (!isValidPostalCode) {
            setFilterEmptyText(t('applicantWatcher.invalidPostalCode'));
            return;
        }

        if (normalizedPostalCode !== code) {
            setPostalCode(normalizedPostalCode);
        }

        setFilterEmptyText("");
        const resolvedCity = await resolveCityByPostalCode(normalizedPostalCode);
        await updateApartmentsData(normalizedPostalCode, resolvedCity);
    }

    const filterApplications = async () => {
        await applyFilter(postalCode);
    };


    const handleClickContactOpen = async (applicant) => {
        setLoading(true);
        if (loggedUserId) {
            try {
                const apartments = await ApartmentsApi.getApartments({ status: 'marketing' });
                const marketingOrConfirmedApartments = apartments.filter(apartment => apartment.status === "marketing" || apartment.status === "confirmed");
                setMarketingOrConfirmedApartments(marketingOrConfirmedApartments);
            } catch (error) {
                // Optionally, you can set marketingOrConfirmedApartments to an empty array if the API call fails
                setMarketingOrConfirmedApartments([]);
            }
        } else {
            setMarketingOrConfirmedApartments([]);
        }
        setSelectedApplicant(applicant);
        setOpen(true);
        setLoading(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleContactApplicant = async () => {
        setLoading(true);
        setOpen(false);
        // let response
        const randomTimeout = Math.random() * (1000 - 500) + 500; // Random timeout between 0.5 to 1 second
        await new Promise(resolve => setTimeout(resolve, randomTimeout));
        const message = t('applicantWatcher.contactApplicantSuccessMessage')
        toast.info(message, { autoClose: 25000 })
        // if (loggedUserId) {
        //     response = await Api.contactApplicant(selectedApplicant.applicationId, selectedApplicant.apartmentId, loggedUserId);
        // } else {
        //     console.log("not logged in");
        // }
        setLoading(false);
    };

    // useEffect(() => {

    //     //console.log(applications);

    // }, [applications]);

    useEffect(() => {
        fetchApplications();
    }, []);

    useEffect(() => {
        if (hasPrefilledPostalCode || postalCode) {
            return;
        }

        let isMounted = true;

        const prefillPostalCodeFromApartments = async () => {
            try {
                const apartmentsResponse = await ApartmentsApi.getApartments({ status: 'marketing' });
                const marketingOrConfirmed = apartmentsResponse.filter(
                    (apartment: any) =>
                        apartment.status === 'marketing' || apartment.status === 'confirmed'
                );

                if (!isMounted || !marketingOrConfirmed.length) {
                    return;
                }

                setMarketingOrConfirmedApartments(marketingOrConfirmed);

                const firstPostalCode = marketingOrConfirmed[0]?.information?.postalCode;
                if (firstPostalCode) {
                    const normalizedCode = firstPostalCode.toString().trim();
                    setPostalCode(normalizedCode);
                    setHasPrefilledPostalCode(true);
                }
            } catch (error) {
                if (isMounted) {
                    console.error('Failed to prefill postal code from active apartments', error);
                }
            }
        };

        prefillPostalCodeFromApartments();

        return () => {
            isMounted = false;
        };
    }, [hasPrefilledPostalCode, postalCode]);

    useEffect(() => {
        if (
            !hasPrefilledPostalCode ||
            autoFilterApplied ||
            !postalCode ||
            !/^\d{5}$/.test(postalCode) ||
            !allApplications.length
        ) {
            return;
        }

        const runFilter = async () => {
            await applyFilter(postalCode);
            setAutoFilterApplied(true);
        }

        runFilter();
    }, [hasPrefilledPostalCode, autoFilterApplied, postalCode, allApplications.length]);

    return (
        <>
            {isLoading === true || isFiltering ? (
                <LoadingContainer />
            ) : (
                <div className={classes.mainContainer}>
                    <div className={classes.maxWidthContainer}>
                        <div className={classes.headerMargin}>
                            <div className={classes.headerRow}>
                                <Typography variant="h4" gutterBottom>
                                    {t('applicantWatcher.activeApplicants')}
                                </Typography>
                                <Typography variant="h6" gutterBottom className={classes.applicantCounter}>
                                    <span className={classes.orangeText}>{totalApplications}</span>
                                    {t('applicantWatcher.applicants')}
                                </Typography>
                            </div>
                        </div>


                        <Grid container spacing={3} className={classes.container}>
                            {/* <Grid item md={2} xs={12} className={`${classes.inputFieldMargin}`}>
                                <input
                                    className={`${classes.inputField}`}
                                    type="text"
                                    placeholder={t('applicantWatcher.squareMeters')}
                                    value={squareMeters}
                                    onChange={(e) => {
                                        // Replace non-numeric characters including dot and comma with an empty string
                                        const newValue = e.target.value.replace(/[^\d.]/g, '');
                                        setSquareMeters(newValue);
                                    }}
                                    inputMode="numeric" // Set input mode to accept numeric input
                                    pattern="[0-9.]*" // Set pattern to allow numeric characters, dot, and comma
                                />
                            </Grid> */}
                            <Grid item xs={12} md={8} className={classes.filterControls}>
                                <FormControl fullWidth variant="outlined" className={classes.filterInput}>
                                    <OutlinedInput
                                        fullWidth
                                        placeholder={t('applicantWatcher.postalCode')}
                                        endAdornment={
                                            <InputAdornment position="end" >
                                                {postalCode && <IconButton
                                                    aria-label="toggle postal code"
                                                    onClick={async () => {
                                                        setPostalCode('')
                                                        await applyFilter('', { allowEmpty: true })
                                                    }}
                                                >
                                                    <CloseCircleIcon />
                                                </IconButton>}
                                            </InputAdornment>
                                        }

                                        value={postalCode}
                                        onChange={(e) => {
                                            const newValue = e.target.value
                                            setPostalCode(newValue);
                                        }}
                                    />
                                </FormControl>
                                <Button variant="contained" color="primary" onClick={filterApplications} className={classes.filterButton}>
                                    {t('applicantWatcher.filterApplicants')}
                                </Button>
                            </Grid>
                            {filterEmptyText !== "" && (
                                <Grid item xs={12} className={classes.filterEmptyTextContainer}>
                                    <Typography variant="body1" style={{ color: '#ff0000' }}>
                                        {filterEmptyText}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>


                        {/* // {1 !== 1 ? ( */}
                        {applications.length > 0 ? (
                            <Grid container spacing={3} className={`${classes.container} ${classes.lastChildPadding}`}>
                                {applications.map((app, index) => (
                                    <Grid item md={6} xs={12} key={index}>
                                        {app.data && app.data.name ? (
                                            <Card style={{ border: '1px solid #F1F5F8', boxShadow: 'none', borderRadius: '18px' }}>
                                                <CardContent>
                                                    <Grid container style={{ marginTop: '14px' }}>
                                                        <Grid item md={4} xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <div>
                                                                <Icon>
                                                                    {app.data && app.data.profilePicture ? (
                                                                        <img src={'https://' + config.s3.profilePictures.BUCKET + '.s3.' + config.s3.profilePictures.REGION + '.amazonaws.com/' + app.data.profilePicture} alt="Avatar" style={{ width: '128px', height: '128px', borderRadius: '50%' }} />
                                                                    ) : (
                                                                        <img src={avatar} alt="Avatar" />
                                                                    )}
                                                                </Icon>
                                                            </div>
                                                            <Hidden mdUp>
                                                                <div style={{ marginTop: '8px', marginBottom: '8px' }}>
                                                                    <Typography variant="h5" component="h2">
                                                                        {app.data.name.split(' ')[0]}
                                                                    </Typography>
                                                                </div>
                                                            </Hidden>
                                                            <div style={{ marginTop: 'auto', marginBottom: '20px', textAlign: 'center' }}>
                                                                <Button variant="contained" color="primary" onClick={() => handleClickContactOpen(app)}>
                                                                    {t('applicantWatcher.contact')}
                                                                </Button>
                                                            </div>
                                                        </Grid>
                                                        <Grid item md={8} xs={12}>
                                                            <Hidden smDown>
                                                                <div style={{ marginLeft: '15px' }}>
                                                                    <Typography variant="h5" component="h2">
                                                                        {app.data.name.split(' ')[0]}
                                                                    </Typography>
                                                                </div>
                                                            </Hidden>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={4}>
                                                                    <List>
                                                                        <ListItem>
                                                                            <Grid container direction="column" alignItems="flex-start">
                                                                                <ListItemIcon>
                                                                                    <img src={peopleAmount} alt="People Amount" style={{ marginBottom: '3px', marginTop: '2px' }} />
                                                                                </ListItemIcon>
                                                                                <Typography color="textSecondary">
                                                                                    {t('applicantWatcher.peopleAmount')}
                                                                                </Typography>
                                                                                <Typography color="textSecondary" style={{ color: '#141414', fontSize: '16px' }}>
                                                                                    {t(`applicantWatcher.movingWith.${app.data.movingWith}`)}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </ListItem>
                                                                        <ListItem>
                                                                            <Grid container direction="column" alignItems="flex-start">
                                                                                <ListItemIcon>
                                                                                    <img src={lifeSituation} alt="Life Situation" />
                                                                                </ListItemIcon>
                                                                                <Typography color="textSecondary" style={{ color: '#8E9498', fontSize: '15px' }}>
                                                                                    {t('applicantWatcher.lifeSituation')}
                                                                                </Typography>
                                                                                <Typography color="textSecondary" style={{ color: '#141414', fontSize: '16px' }}>
                                                                                    {t(`application.lifeSituation.${app.data.lifeSituation}`)}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </ListItem>
                                                                    </List>
                                                                </Grid>

                                                                <Grid item xs={4}>
                                                                    <List>
                                                                        <ListItem>
                                                                            <Grid container direction="column" alignItems="flex-start">
                                                                                <ListItemIcon>
                                                                                    <img src={pets} alt="Pets" />
                                                                                </ListItemIcon>
                                                                                <Typography color="textSecondary">
                                                                                    {t('applicantWatcher.pets')}
                                                                                </Typography>
                                                                                <Typography color="textSecondary" style={{ color: '#141414', fontSize: '16px' }}>
                                                                                    {t(`application.pets.${app.data.pets}`)}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </ListItem>
                                                                        <ListItem>
                                                                            <Grid container direction="column" alignItems="flex-start">
                                                                                <ListItemIcon>
                                                                                    <img src={creditStatus} alt="Credit Status" />
                                                                                </ListItemIcon>
                                                                                <Typography color="textSecondary">
                                                                                    {t('applicantWatcher.creditStatus')}
                                                                                </Typography>
                                                                                <Typography color="textSecondary" style={{ color: '#141414', fontSize: '16px' }}>
                                                                                    {t(`application.creditStatus.${app.data.creditStatus}`)}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </ListItem>
                                                                    </List>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <List>
                                                                        <ListItem>
                                                                            <Grid container direction="column" alignItems="flex-start">
                                                                                <ListItemIcon>
                                                                                    <img src={ageGroup} alt="Age Group" />
                                                                                </ListItemIcon>
                                                                                <Typography color="textSecondary">
                                                                                    {t('applicantWatcher.ageGroup')}
                                                                                </Typography>
                                                                                <Typography color="textSecondary" style={{ color: '#141414', fontSize: '16px' }}>
                                                                                    {t(`applicantWatcher.ageGroups.${app.data.age}`)}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </ListItem>
                                                                        <ListItem>
                                                                            <Grid container direction="column" alignItems="flex-start">
                                                                                <ListItemIcon>
                                                                                    <img src={depositMethod} alt="Deposit Method" />
                                                                                </ListItemIcon>
                                                                                <Typography color="textSecondary">
                                                                                    {t('applicantWatcher.deposit')}
                                                                                </Typography>
                                                                                <Typography color="textSecondary" style={{ color: '#141414', fontSize: '16px' }}>
                                                                                    {t(`application.depositPaymentMethod.${app.data.depositPaymentMethod}`)}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </ListItem>
                                                                    </List>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        ) : null}
                                    </Grid>
                                ))}

                                {cache.length > 0 && (
                                    <Grid container style={{ marginTop: '1.2rem', marginBottom: '50px' }}>
                                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                                            <Button variant="outlined" color="primary" onClick={handleLoadMore} style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                                                {t('applicantWatcher.loadMore')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}

                                {!loggedUserId &&
                                    <Fragment>
                                        <Grid container spacing={3} className={classes.magicBox} >
                                            <Grid container className={classes.contactPageAdContainer3} alignItems="center">
                                                <Grid item md={12} xs={12}>
                                                    <Typography className={classes.adTitle3}>{t('applicantWatcher.lookingForATenantText1')}</Typography>
                                                    <Typography className={classes.adText2}>{t('applicantWatcher.lookingForATenantText2')}</Typography>
                                                </Grid>
                                                {/* <Grid item md={12} xs={12} style={{ marginBottom: '2rem' }}> */}
                                                <Grid item md={12} xs={12}>
                                                    <a href="https://app.leea.fi/create/apartment/steps/0" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                                        <Button className={classes.createAdButton2} variant="contained" color="primary">
                                                            {t('applicantWatcher.createAdvertisement')}
                                                        </Button>
                                                    </a>
                                                </Grid>
                                            </Grid>
                                            <Grid container xs={12} className={classes.noHitsContainer3}>
                                                <Grid container direction="column" alignItems="center" justifyContent="center">
                                                    <Typography className={classes.adTitle}>
                                                        {t('applicantWatcher.adTitle')}
                                                    </Typography>
                                                    {/* Manually created grid for bullet points */}
                                                    <Grid container spacing={2} justifyContent="center" className={classes.factsContainer}>
                                                        {/* Row 1 */}
                                                        <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                            <Typography>{t('applicantWatcher.point1')}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                            <Typography>{t('applicantWatcher.point2')}</Typography>
                                                        </Grid>
                                                        {/* Row 2 */}
                                                        <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                            <Typography>{t('applicantWatcher.point3')}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                            <Typography>{t('applicantWatcher.point4')}</Typography>
                                                        </Grid>
                                                        {/* Row 3 */}
                                                        <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                            <Typography>{t('applicantWatcher.point5')}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                            <Typography>{t('applicantWatcher.point6')}</Typography>
                                                        </Grid>
                                                    </Grid>

                                                    {/* <Typography variant="h6" gutterBottom className={`${classes.applicantCounter} ${classes.priceContainer}`}>
                                                <span className={classes.orangeText}>85 €</span>
                                                <span className={`${classes.perRent}`}>
                                                    / {t('applicantWatcher.perRent')}</span>
                                            </Typography> */}
                                                    <Grid container className={classes.priceDisclaimerContainer}>
                                                        <Grid item xs={12} alignItems="center">
                                                            {/* Left section */}
                                                            <Grid item xs={12} md={12}>
                                                                <Grid container alignItems="center" className={classes.leftSection}>
                                                                    {/* <Grid item  style={{ paddingRight: '14px', alignSelf: 'flex-start' }}> */}
                                                                    <Grid item style={{ paddingRight: '14px' }}>
                                                                        {/* Icon for suggestion */}
                                                                        <img src={suggestIcon} alt="Suggest Icon" />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        {/* Content for the left side */}
                                                                        <Typography className={`${classes.customSuggestTextStyles}`}>
                                                                            {t('applicantWatcher.priceDisclaimer')}
                                                                            <a href="https://leea.fi" target="_blank" rel="noopener noreferrer" style={{ color: '#94004A' }}>
                                                                                {t('applicantWatcher.here')}.
                                                                            </a>
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Fragment>
                                }

                            </Grid>
                        ) : (
                            <Grid container spacing={3}>
                                <Grid item xs={12} className={classes.noHitsContainer1}>
                                    <Grid container direction="column" alignItems="center" justifyContent="center">
                                        <img src={searchDude} alt="Guy" className={`${classes.searchDudeIcon}`} />
                                        <Typography className={`${classes.largeText}`}>
                                            {t('applicantWatcher.notFound1')}
                                        </Typography>
                                        <Typography className={`${classes.smallText}`}>
                                            {t('applicantWatcher.notFound2')}
                                        </Typography>
                                        {!loggedUserId && <a href="https://leea.fi" target="_blank" rel="noopener noreferrer">
                                            <Button variant="contained" color="primary" fullWidth className={`${classes.goToLeeaButton}`}>
                                                {t('applicantWatcher.notFoundButton')}
                                            </Button>
                                        </a>}
                                    </Grid>
                                </Grid>
                                {!loggedUserId && <Grid item xs={12} className={classes.noHitsContainer2}>
                                    <Grid container direction="column" alignItems="center" justifyContent="center">
                                        <Typography className={classes.adTitle}>
                                            {t('applicantWatcher.adTitle')}
                                        </Typography>
                                        {/* Manually created grid for bullet points */}
                                        <Grid container item spacing={2} justifyContent="center" className={classes.factsContainer}>
                                            {/* Row 1 */}
                                            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                <Typography>{t('applicantWatcher.point1')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                <Typography>{t('applicantWatcher.point2')}</Typography>
                                            </Grid>
                                            {/* Row 2 */}
                                            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                <Typography>{t('applicantWatcher.point3')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                <Typography>{t('applicantWatcher.point4')}</Typography>
                                            </Grid>
                                            {/* Row 3 */}
                                            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                <Typography>{t('applicantWatcher.point5')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                <Typography>{t('applicantWatcher.point6')}</Typography>
                                            </Grid>
                                        </Grid>
                                        {/* <Typography variant="h6" gutterBottom className={`${classes.applicantCounter} ${classes.priceContainer}`}>
                                            <span className={classes.orangeText}>85 €</span>
                                            <span className={`${classes.perRent}`}>
                                                / {t('applicantWatcher.perRent')}</span>
                                        </Typography>
                                        <Typography className={`${classes.readMore}`}>
                                            <span>{t('applicantWatcher.readMore')}</span>
                                            <a href="https://leea.fi" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#94004A' }}>
                                                {t('applicantWatcher.here')}
                                            </a>
                                        </Typography> */}
                                        <Grid container className={classes.priceDisclaimerContainer}>
                                            <Grid item xs={12} alignItems="center">
                                                {/* Left section */}
                                                <Grid item xs={12} md={12}>
                                                    <Grid container alignItems="center" className={classes.leftSection}>
                                                        {/* <Grid item  style={{ paddingRight: '14px', alignSelf: 'flex-start' }}> */}
                                                        <Grid item style={{ paddingRight: '14px' }}>
                                                            {/* Icon for suggestion */}
                                                            <img src={suggestIcon} alt="Suggest Icon" />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            {/* Content for the left side */}
                                                            <Typography className={`${classes.customSuggestTextStyles}`}>
                                                                {t('applicantWatcher.priceDisclaimer')}
                                                                <a href="https://leea.fi" target="_blank" rel="noopener noreferrer" style={{ color: '#94004A' }}>
                                                                    {t('applicantWatcher.here')}.
                                                                </a>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                }
                            </Grid>
                        )}
                        <Dialog
                            fullScreen={fullScreen}
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="form-dialog-title"
                            classes={{ paper: classes.roundedDialog }} // Applying custom styles for the first dialog
                        >
                            {/* <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>{t('applicantWatcher.contact')} {selectedApplicant && selectedApplicant.data.name.split(' ')[0]}.</DialogTitle> */}
                            <DialogContent style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '8px', paddingRight: '4px', marginBottom: '-8px' }}>
                                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                                    <img src={closeIcon} alt="Close Dialog" />
                                </IconButton>
                            </DialogContent>
                            <DialogContent>
                                {/* <DialogContentText>
                                {loggedUserId ? "You are currently logged in." : "You are not logged in."}
                            </DialogContentText> */}

                                {marketingOrConfirmedApartments.length === 0 ? (
                                    <div>
                                        <Grid item container className={classes.contactPageAdContainer1}>
                                            <Grid item md={6} xs={12}>
                                                <Typography className={classes.adTitle2}>{t('applicantWatcher.lookingForATenantText1')}</Typography>
                                                <Typography className={classes.adText}>{t('applicantWatcher.lookingForATenantText2')}</Typography>
                                            </Grid>
                                            <Grid item md={6} xs={12}>
                                                <a href="https://app.leea.fi/create/apartment/steps/0" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                                    <Button className={classes.createAdButton} variant="contained" color="primary">
                                                        {t('applicantWatcher.createAdvertisement')}
                                                    </Button>
                                                </a>
                                            </Grid>
                                        </Grid>
                                        {/* <Typography variant="h6" gutterBottom className={`${classes.applicantCounter} ${classes.priceContainer}`} style={{ display: 'flex', justifyContent: 'center', margin: 'auto', marginBottom: '1.8rem' }}>
                                        <span style={{ color: '#FFBA57' }}>{t('applicantWatcher.forFree')}</span>
                                    </Typography>*/}

                                        <Grid item xs={12} className={classes.contactPageAdContainer2}>
                                            <Grid container direction="column" alignItems="center" justifyContent="center">
                                                <Typography className={classes.adTitle}>
                                                    {t('applicantWatcher.adTitle')}
                                                </Typography>
                                                {/* Manually created grid for bullet points */}

                                                <Grid container item spacing={2} justifyContent="center" className={classes.factsContainer2}>
                                                    {/* Row 1 */}
                                                    <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                        <Typography>{t('applicantWatcher.point1')}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                        <Typography>{t('applicantWatcher.point2')}</Typography>
                                                    </Grid>
                                                    {/* Row 2 */}
                                                    <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                        <Typography>{t('applicantWatcher.point3')}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                        <Typography>{t('applicantWatcher.point4')}</Typography>
                                                    </Grid>
                                                    {/* Row 3 */}
                                                    <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                        <Typography>{t('applicantWatcher.point5')}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={checkMark} alt="Check Mark" style={{ marginRight: '10px' }} />
                                                        <Typography>{t('applicantWatcher.point6')}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container className={classes.priceDisclaimerContainer}>
                                                <Grid item xs={12} alignItems="center">
                                                    {/* Left section */}
                                                    <Grid item xs={12} md={12}>
                                                        <Grid container alignItems="center" className={classes.leftSection}>
                                                            {/* <Grid item  style={{ paddingRight: '14px', alignSelf: 'flex-start' }}> */}
                                                            <Grid item style={{ paddingRight: '14px' }}>
                                                                {/* Icon for suggestion */}
                                                                <img src={suggestIcon} alt="Suggest Icon" />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                {/* Content for the left side */}
                                                                <Typography className={`${classes.customSuggestTextStyles}`}>
                                                                    {t('applicantWatcher.priceDisclaimer')}
                                                                    <a href="https://leea.fi" target="_blank" rel="noopener noreferrer" style={{ color: '#94004A' }}>
                                                                        {t('applicantWatcher.here')}.
                                                                    </a>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* <Typography variant="h6" gutterBottom className={`${classes.applicantCounter} ${classes.priceContainer}`}>
                                                <span className={classes.orangeText}>85 €</span>
                                                <span className={`${classes.perRent}`}>
                                                    / {t('applicantWatcher.perRent')}</span>
                                            </Typography>
                                            <Typography className={`${classes.readMore}`}>
                                                <span>{t('applicantWatcher.readMore')}</span>
                                                <a href="https://leea.fi" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#94004A' }}>
                                                    {t('applicantWatcher.here')}
                                                </a>
                                            </Typography> */}
                                        </Grid>
                                    </div>
                                ) : (
                                    <div>
                                        <span id="form-dialog-title" className={classes.dialogTitle}>{t('applicantWatcher.contactPerson')} {selectedApplicant && selectedApplicant.data.name.split(' ')[0]}.</span>
                                        <Grid container spacing={2} alignItems="center" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>{t('applicantWatcher.apartmentDropdownTitle')}</Typography>
                                                <div className={classes.selectContainer}>
                                                    <select className={classes.selectDropdown}>
                                                        {marketingOrConfirmedApartments.map(apartment => (
                                                            <option key={apartment.id} value={apartment.information.address}>
                                                                {apartment.information.address}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', margin: 'auto', }}>
                                                <Button className={classes.contactApplicantButton} onClick={handleContactApplicant} variant="contained" color="primary">
                                                    {t('applicantWatcher.contactApplicant')}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                )}
                            </DialogContent>
                            {/* <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                {t('applicantWatcher.cancel')}
                            </Button>
                            <Button onClick={handleContactApplicant} color="primary">
                                {t('applicantWatcher.contact')}
                            </Button>
                        </DialogActions> */}
                        </Dialog>
                    </div>
                </div >
            )}
        </>
    );
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
    return {};
}

const mapStateToProps = (state: any): PropsFromState => {
    return {};
}

const styles = (theme: Theme) =>
    createStyles({
        mainContainer: {
            maxWidth: '1131px',
            margin: 'auto',
            overflow: 'hidden',
            '@media (max-width: 499.95px)': {
                paddingLeft: theme.spacing(0.75),
                paddingRight: theme.spacing(0.75),
            },
            '@media (min-width: 500px) and (max-width: 1250px)': {
                paddingLeft: theme.spacing(8),
                paddingRight: theme.spacing(8),
            },
        },
        maxWidthContainer: {
            maxWidth: '97%',
            margin: 'auto',
        },
        inputContainer: {
            display: 'flex',
            justifyContent: 'center', // Center the children horizontally
            alignItems: 'center', // Center the children vertically
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'flex-start', // Align to the start on small screens
            },
        },
        selectContainer: {
            position: 'relative'
        },
        selectDropdown: {
            width: '100%',
            padding: '10px',
            fontSize: '16px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            backgroundColor: '#E7ECEF'
        },
        selectDropdownFocus: {
            outline: 'none',
            borderColor: '#670033'
        },
        inputField: {
            height: '20px', // Adjust height of input field
            width: '100%',
            //maxWidth: 'none', // Set maximum width to prevent excessive width
            backgroundColor: '#E7ECEF', // Darker background color
            borderRadius: '5px', // Adjust border radius
            padding: '10px', // Adjust padding
            color: '#000', // Text color
            fontSize: '16px', // Font size
            border: 'none', // Remove default border
            outline: 'none',
        },
        inputFieldMargin: {
            marginRight: '0.6rem',
            '@media (max-width: 960px)': {
                marginRight: theme.spacing(2.5)
            },
        },

        "& .inputField:focus": {
            border: '1px solid #E7ECEF', /* Thin border when focused */
        },

        "& .inputField::placeholder": {
            color: '#000', /* Set placeholder text color to black */
        },

        container: {
            marginTop: theme.spacing(0.5),
            // marginLeft: theme.spacing(1),
            // marginRight: theme.spacing(1),
            //margin: '0px',
            padding: theme.spacing(1),
            '& .MuiTextField-root': {
                backgroundColor: '#f2f2f2', // Grey background color
                borderRadius: '4px', // Rounded corners
                // '& input': {
                //     padding: '10px', // Adjust input padding
                //     textAlign: 'center', // Center align text
                //     fontSize: '14px', // Adjust font size
                // },
                // '& input::placeholder': {
                //     color: '#666', // Darker grey placeholder text
                //     textAlign: 'center', // Center align placeholder text
                // },
            },
        },
        roundedDialog: {
            borderRadius: theme.spacing(1), // Adjust the radius as needed
            [theme.breakpoints.down('sm')]: {
                display: 'block',
            },
        },
        filterControls: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2),
            width: '100%',
            [theme.breakpoints.down('xs')]: {
                gap: theme.spacing(1),
            },
        },
        filterInput: {
            flexGrow: 1,
        },
        filterButton: {
            minHeight: 56,
            whiteSpace: 'nowrap',
        },
        filterEmptyTextContainer: {
            marginTop: theme.spacing(1),
        },
        priceDisclaimerContainer: {
            width: '90%',
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(3),
            justifyContent: 'space-between',
            borderRadius: theme.spacing(1), // Adjust border radius as needed
            backgroundColor: '#FBF6EE',
            marginBottom: theme.spacing(5),
            marginTop: theme.spacing(5),
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            [theme.breakpoints.down('sm')]: {
                width: '90%',
                padding: theme.spacing(2),
            },
        },
        noHitsContainer1: {
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.spacing(1),
            backgroundColor: '#F7F8F9',
            marginBottom: '1.5rem',
            marginTop: theme.spacing(4),
            marginLeft: theme.spacing(2.5),
            marginRight: theme.spacing(2.5),
        },
        searchDudeIcon: {
            marginTop: theme.spacing(4.5),
            '@media (max-width: 600px)': {
                marginTop: '1.8rem'
            },
        },
        goToLeeaButton: {
            marginBottom: theme.spacing(4.7),
            '@media (max-width: 600px)': {
                marginBottom: '1.5rem'
            },
        },
        largeText: {
            fontSize: theme.spacing(3), // Adjust size as needed
            marginTop: theme.spacing(1.7),
            marginBottom: theme.spacing(0.8),
            //fontWeight: theme.typography.fontWeightLight,
            fontFamily: 'CircularBold', // Adjust vertical space as needed
        },
        adTitle: {
            fontSize: theme.spacing(3), // Adjust size as needed
            marginTop: theme.spacing(4.5),
            '@media (max-width: 600px)': {
                marginTop: '1.5rem'
            },
            marginBottom: theme.spacing(3.5),
            fontFamily: 'CircularBold',
            textAlign: 'center'// Adjust vertical space as needed
        },
        adTitle2: {
            fontSize: theme.spacing(3), // Adjust size as needed
            marginTop: theme.spacing(4.5),
            marginBottom: theme.spacing(3.5),
            fontFamily: 'CircularBold',
            '@media (max-width: 960px)': {
                textAlign: 'center',
                marginTop: theme.spacing(3.7),
                marginBottom: theme.spacing(2.3),
            },
            '@media (min-width: 960px)': {
                marginLeft: '2rem'
            },
        },
        adTitle3: {
            fontSize: theme.spacing(3), // Adjust size as needed
            marginTop: theme.spacing(3.5),
            marginBottom: theme.spacing(3.5),
            fontFamily: 'CircularBold',
            textAlign: 'center',
            '@media (max-width: 960px)': {
                marginTop: theme.spacing(3.7),
                marginBottom: theme.spacing(2.3),
            },

        },
        adText2: {
            //fontSize: theme.spacing(3), // Adjust size as needed
            marginTop: theme.spacing(3),

            marginBottom: theme.spacing(3.5),
            textAlign: 'center',
            // fontFamily: 'CircularBold',
            '@media (max-width: 960px)': {

                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(2.5),
            },
            '@media (min-width: 960px)': {
                marginLeft: '2rem'
            },
            // Adjust vertical space as needed
        },
        adText: {
            //fontSize: theme.spacing(3), // Adjust size as needed
            marginTop: theme.spacing(3),

            marginBottom: theme.spacing(3.5),
            // fontFamily: 'CircularBold',
            '@media (max-width: 960px)': {
                textAlign: 'center',
                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(2.5),
            },
            '@media (min-width: 960px)': {
                marginLeft: '2rem'
            },
            // Adjust vertical space as needed
        },
        smallText: {
            fontWeight: theme.typography.fontWeightLight,
            fontFamily: 'CircularRegular',
            fontSize: '1rem', // Adjust size as needed
            marginBottom: theme.spacing(2.2), // Adjust vertical space as needed
        },
        priceContainer: {
            marginBottom: theme.spacing(3.3),
            marginTop: `28px !important`, // Adding !important here
        },
        noHitsContainer2: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.spacing(1),
            //backgroundColor: '#F7F8F9',
            marginBottom: '2.2rem',
            marginTop: theme.spacing(2),
            marginLeft: theme.spacing(2.5),
            marginRight: theme.spacing(2.5),
            border: '1px solid #F1F5F8',
        },
        noHitsContainer3: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.spacing(1),
            //backgroundColor: '#F7F8F9',
            marginBottom: '2rem',
            marginTop: theme.spacing(1.5),
            marginLeft: theme.spacing(2.72),
            marginRight: theme.spacing(2.72),
            border: '1px solid #F1F5F8',
        },
        contactPageAdContainer1: {
            // textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.spacing(1),
            backgroundColor: '#F7F8F9',
            marginBottom: '1.5rem',
            marginTop: theme.spacing(4),
            marginLeft: theme.spacing(0),
            marginRight: theme.spacing(1),
        },
        contactPageAdContainer3: {
            // textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.spacing(1),
            backgroundColor: '#F7F8F9',
            marginBottom: '1.5rem',
            marginTop: theme.spacing(4),
            marginLeft: theme.spacing(2.72),
            marginRight: theme.spacing(2.72),

        },
        magicBox: {
            // '@media (max-width: 500px)': {
            //     paddingLeft: '12px',
            //     paddingRight: '12px',
            // },
        },
        contactPageAdContainer2: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.spacing(1),
            //backgroundColor: '#F7F8F9',
            marginBottom: '1.7rem',
            marginTop: theme.spacing(2),
            //marginLeft: theme.spacing(1),
            //marginRight: theme.spacing(1),
            border: '1px solid #F1F5F8',
        },
        factsContainer: {
            paddingLeft: '23%',
            paddingRight: '19%',
            '@media (max-width: 960px)': {
                paddingLeft: '29%',
            },
            '@media (max-width: 850px)': {
                paddingLeft: '26%',
            },
            '@media (max-width: 750px)': {
                paddingLeft: '22%',
            },
            '@media (max-width: 650px)': {
                paddingLeft: '5%',
            },
        },
        factsContainer2: {
            paddingLeft: '6%',
            paddingRight: '4%',
            '@media (max-width: 960px)': {
                paddingLeft: '22%',
            },
            '@media (max-width: 600px)': {
                paddingLeft: '5%',
            },
        },
        customSuggestTextStyles: {
            //fontSize: '1.125rem',
            fontWeight: theme.typography.fontWeightLight,
            fontFamily: 'CircularRegular',
            fontStyle: 'normal',
            maxWidth: '97%',
            //lineHeight: '1.625rem',
            textAlign: 'left',
            fontSize: theme.typography.pxToRem(14), // Adjust the font size as needed
            lineHeight: theme.typography.pxToRem(20),
            [theme.breakpoints.down('sm')]: {
                maxWidth: '100%',
                display: 'inline',
                // lineHeight: '1.1',
                //fontSize: theme.typography.pxToRem(28)
            }
        },
        leftSection: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap', // Prevent wrapping on smaller screens
        },
        title: {
            marginRight: theme.spacing(1),
        },
        counter: {
            color: 'orange',
        },
        headerMargin: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            marginTop: theme.spacing(6.5),
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(4),
            },
        },
        headerRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column', // On xs screens, stack them vertically
                textAlign: 'center', // Center align text on xs screens
            },
        },
        orangeText: {
            color: '#FFBA57',
            marginRight: theme.spacing(1),
        },
        applicantCounter: {
            display: 'flex',
            // justifyContent: 'flex-end',
            alignItems: 'center',
            width: 'fit-content',
            borderRadius: theme.spacing(1), // Adjust border radius as needed
            backgroundColor: '#FBF6EE',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            [theme.breakpoints.down('xs')]: {
                marginTop: theme.spacing(1),
                //flexDirection: 'column', // On xs screens, stack them vertically
                textAlign: 'center', // Center align text on xs screens
            },
        },
        lastChildPadding: {
            '& .MuiCardContent-root:last-child': {
                paddingBottom: 16,
            },
        },
        orderWatcherErrorTextContainer: {
            marginTop: '10px',
            marginBottom: '-10px',
        },
        perRent: {
            fontFamily: 'CircularBold',
        },
        readMore: {
            marginBottom: '2.5rem',
            '@media (max-width: 600px)': {
                marginBottom: '1.2rem'
            },
        },
        dialogTitle: {
            fontSize: theme.spacing(3), // Adjust size as needed
            fontFamily: 'CircularBold',
            //marginLeft: theme.spacing(1),
            // Adjust vertical space as needed
        },
        closeButton: {
            //position: 'absolute',
            // right: 10,
            // top: 10,
        },
        createAdButton: {
            display: 'flex',
            justifyContent: 'center',
            margin: 'auto',
            paddingTop: '6px',
            paddingBottom: '6px',
            paddingLeft: '16px',
            paddingRight: '16px',
            '@media (max-width: 960px)': {
                marginBottom: theme.spacing(3.5),
            },
        },
        createAdButton2: {
            display: 'flex',
            justifyContent: 'center',
            margin: 'auto',
            paddingTop: '6px',
            paddingBottom: '6px',
            marginBottom: theme.spacing(3),
        }
    });


export default connect<PropsFromState, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withTranslation()(ApplicantWatcher)));
